import { Capacitor, registerPlugin } from '@capacitor/core';

export const isNativeApp = () => Capacitor.isNativePlatform();

const BackgroundGeolocation = registerPlugin('BackgroundGeolocation');

let notifPermAsked = false;

export async function ensureNotifPermission() {
  if (!isNativeApp()) return false;
  try {
    const { LocalNotifications } = await import('@capacitor/local-notifications');
    const perm = await LocalNotifications.checkPermissions();
    if (perm.display === 'granted') return true;
    if (notifPermAsked) return false;
    notifPermAsked = true;
    const req = await LocalNotifications.requestPermissions();
    return req.display === 'granted';
  } catch (err) { console.debug('native: notif permission check failed', err); return false; }
}

export async function nativeNotify(id, title, body) {
  if (!isNativeApp()) return;
  try {
    if (!(await ensureNotifPermission())) return;
    const { LocalNotifications } = await import('@capacitor/local-notifications');
    await LocalNotifications.schedule({ notifications: [{ id, title, body }] });
  } catch (err) { console.debug('native: non-fatal', err); }
}

export async function startNativeWatcher({ onPoint, onError, distanceFilter = 25 }) {
  const id = await BackgroundGeolocation.addWatcher(
    {
      backgroundTitle: 'Sahakar Group — location active',
      backgroundMessage: 'Your location is shared with your organisation while you are signed in.',
      requestPermissions: true,
      stale: false,
      distanceFilter,
    },
    (location, error) => {
      if (error) {
        if (error.code === 'NOT_AUTHORIZED') {
          try { BackgroundGeolocation.openSettings(); } catch (err) { console.debug('native: non-fatal', err); }
        }
        onError?.(error);
        return;
      }
      onPoint?.({
        lat: location.latitude,
        lng: location.longitude,
        accuracy: Number.isFinite(location.accuracy) ? location.accuracy : undefined,
        speed: Number.isFinite(location.speed) && location.speed >= 0 ? location.speed : undefined,
        heading: Number.isFinite(location.bearing) ? location.bearing : undefined,
        altitude: Number.isFinite(location.altitude) ? location.altitude : undefined,
        timestamp: new Date(location.time || Date.now()).toISOString(),
      });
    }
  );
  return id;
}

export async function stopNativeWatcher(id) {
  if (!id) return;
  try { await BackgroundGeolocation.removeWatcher({ id }); } catch (err) { console.debug('native: non-fatal', err); }
}

let shellInited = false;

export async function initNativeShell() {
  if (!isNativeApp() || shellInited) return;
  shellInited = true;
  try {
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.minimizeApp();
    });
  } catch (err) { console.debug('native: non-fatal', err); }
}
